import { ActionRecord } from '@rygen/rygen-ui/model';

export class CheckCallStatus {
  active?: boolean;
  latestRecord?: ActionRecord;

  constructor(opts?: Partial<CheckCallStatus>) {
    if (opts?.active != null) {
      this.active = opts.active;
    }
    if (opts?.latestRecord != null) {
      this.latestRecord = new ActionRecord(opts.latestRecord);
    }
  }
}
